import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from '../button/index';
import { DropdownModule } from '../dropdown/index';
import { IconModule } from '../icon/index';
import { ListModule } from '../list/index';
import { GenericModule } from '../generic/index';

import { TabGroupComponent } from './components/tab-group.component';
import { TabComponent } from './components/tab.component';

import { TabLabelDirective } from './directives/label.directive';

export { TabGroupComponent, TabChangeEvent } from './components/tab-group.component';
export { TabComponent } from './components/tab.component';
export { TabLabelDirective } from './directives/label.directive';

@NgModule({
  declarations: [
    TabGroupComponent,
    TabComponent,

    TabLabelDirective
  ],
  imports: [
    CommonModule,

    ButtonModule,
    DropdownModule,
    IconModule,
    ListModule,
    GenericModule
  ],
  exports: [
    TabGroupComponent,
    TabComponent,

    TabLabelDirective
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class TabsModule {}
